import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import AppLayout from '../layout/AppLayout';
import TokensPage from '../pages/nft-market-place/TokensPage';
import NftCollectionPage from '../pages/nft-market-place/NftCollectionPage';
import { lazyWithRetry } from '../utils/lazyWithRetry';

const MarketPage = lazyWithRetry(() => import('../pages/market'));
const CreatePage = lazyWithRetry(() => import('../pages/create'));
const CollectionPage = lazyWithRetry(() => import('../pages/drop'));
const AboutPage = lazyWithRetry(() => import('../pages/about'));
const Profile = lazyWithRetry(() => import('../pages/profile'));
const MyNft = lazyWithRetry(() => import('../pages/myNft'));
const Dashboard = lazyWithRetry(() => import('../pages/dashboard'));
const Whitepaper = lazyWithRetry(() => import('../pages/whitepaper'));
const Roadmap = lazyWithRetry(() => import('../pages/roadmap'));
const TermsOfService = lazyWithRetry(() => import('../pages/legal-page/legal'));
const StudioPage = lazyWithRetry(() => import('../pages/Home'));

export const router = createBrowserRouter(
  [
    {
      element: <AppLayout />,
      children: [
        {
          path: '/',
          element: <MarketPage />,
        },
        {
          path: '/create',
          element: <CreatePage />,
        },
        {
          path: '/collection',
          element: <CollectionPage />,
        },
        {
          path: '/drop/:id',
          element: <CollectionPage />,
        },
        {
          path: '/about',
          element: <AboutPage />,
        },
        {
          path: '/studio',
          element: <StudioPage />,
        },
        {
          path: '/profile',
          element: <Profile />,
        },
        {
          path: '/my-nft',
          element: <MyNft />,
        },
        {
          path: '/dashboard',
          element: <Dashboard />,
        },
        {
          path: '/whitepaper',
          element: <Whitepaper />,
        },
        {
          path: '/roadmap',
          element: <Roadmap />,
        },
        {
          path: '/marketplace',
          element: <TokensPage />,
        },
        {
          path: '/collection/:chain',
          element: <NftCollectionPage />,
        },
        {
          path: '/legal',
          element: <TermsOfService />,
        },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);
